/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { Header } from "../header";
import { Sticky } from "../../basic/sticky";
import { HeaderSearch } from "../header-search";
import { CtaWrapper, LogoWrapper, SecondaryMenu, DefaultMenu, Login, Monogram } from "../header-helper-components";
import { Sidebar } from "../sidebar";
import { accessCheck } from "../../../../isomorphic/utils";
import { DOUBLE_LAYER_ROOT_MARGIN } from "../../../constants";

import "./header-two.m.css";
import { MobileDownloadLinks } from "../../atoms/mobile-apps";

const HeaderTwo = props => {
  const isSearchFormVisible = get(props, ["header", "isSearchFormVisible"]);
  const showAppDownloadLinks = get(props.enableAppDownloadLinks) === true ? "show-app-download-links" : "";
  const enableAppDownloadLinks =
    get(props.enableAppDownloadLinks) === true ? "app-download-links-enabled" : "secondary-menu";
  return (
    <Sticky rootMargin={DOUBLE_LAYER_ROOT_MARGIN}>
      <article styleName="sticky">
        <div styleName="layer-1">
          {props.enableAppDownloadLinks && (
            <div styleName="download-links">
              <MobileDownloadLinks {...props} />
            </div>
          )}
          <div styleName={`${enableAppDownloadLinks}`}>
            <SecondaryMenu {...props} customCssClasses={("header-two-secondary", `${showAppDownloadLinks}`)} />
          </div>
          <div styleName="logo">
            <LogoWrapper {...props} />
          </div>
          <div styleName="cta-search-wrapper">
            <div styleName="search">
              <HeaderSearch {...props} dataTestId="search-icon-mobile" headerType="header-two" />
            </div>
            <div styleName="cta">
              <CtaWrapper {...props} />
            </div>
            <div styleName="sidebar">
              <Sidebar {...props} {...props.isSidebarVisible} dataTestId="hamburger-icon-mobile" />
            </div>
            {accessCheck(props.enableSSO) && (
              <div styleName="login">
                <Login {...props} />
              </div>
            )}
          </div>
        </div>
        <div styleName={`layer-2 ${isSearchFormVisible ? "hide-search-form" : ""}`}>
          <div styleName="monogram">
            <Monogram {...props} />
          </div>
          <div styleName="default-menu">
            <DefaultMenu {...props} />
          </div>
          <div styleName="search">
            <HeaderSearch {...props} dataTestId="search-icon" />
          </div>
          <div styleName="sidebar">
            <Sidebar {...props} {...props.isSidebarVisible} dataTestId="hamburger-icon" />
          </div>
        </div>
      </article>
    </Sticky>
  );
};

HeaderTwo.propTypes = {
  header: PropTypes.shape({
    isSearchFormVisible: PropTypes.bool
  }),
  isSidebarVisible: PropTypes.bool,
  toggleSearchForm: PropTypes.bool,
  hideSearchForm: PropTypes.bool,
  enableSSO: PropTypes.bool,
  enableAppDownloadLinks: PropTypes.bool
};

const HeaderTemplate = ({ showHeaderRowOnly = false }) => (
  <Header renderTemplate={HeaderTwo} showHeaderRowOnly={showHeaderRowOnly} />
);

HeaderTemplate.propTypes = {
  showHeaderRowOnly: PropTypes.bool
};

export default HeaderTemplate;
